import React, { useEffect, useState } from "react";
import { getUrl } from './apiClient';

const FlashCard = props => {

  const [question, setQuestion] = useState(props.question);
  useEffect(() => { setQuestion(props.question); }, [props]);

  let imageUrl;
  if (question && question.uri) {
    imageUrl = getUrl() + question.uri;
  }

  let width = "400";
  if (imageUrl && imageUrl.match(/fretboard/)) {
    width = "800";
  }

  if (!imageUrl) {
    return (
      <div>
        <img className="flashcard" src={getUrl() + 'images/cards/clefs/treble/keys/C/major/C4.jpg'} width={width} alt="" />
      </div>
    );
  } else {
    return (
      <div>
        <img className="flashcard" src={imageUrl} width={width} alt="" />
      </div>
    );
  }

}

export default FlashCard;

